// extracted by mini-css-extract-plugin
export default {"mainText":"team_mainText__tEDre","wrapper":"team_wrapper__rqaNM","jumbotron":"team_jumbotron__WRGYf"};